import { parseISO } from "date-fns";
import { formatDate } from "utils";

export const isEmailMandatory = (profileType) => {
  return ['mediator', 'case_manager', 'sub_admin_tiac_rv', 'arbitrator_rv'].includes(profileType);
}

export const isNalsarTempEmail = (email) => {
  return typeof email === "string" && email.startsWith("nalsar_temp_email");
}

// Parties added without an email get a nalsar_temp_email placeholder; never show it.
export const displayEmail = (email) => (isNalsarTempEmail(email) ? "" : email);

export const isValidPhone = (phone) => {
  const phoneRegex = /^\d{10}$/;
  return phoneRegex.test(phone);
};

// Date an award was shared.
export const getAwardSharedDate = (award) =>
  award.shared_date
    ? formatDate(parseISO(award.shared_date))
    : formatDate(award.modified);